import {
  takeEvery, call, put,
} from 'redux-saga/effects';
import {
  availableStatesRequest, availableStatesSuccess, availableStatesFailure,
} from '../../slices/user';
import axios from '../axiosConfig';

const queryString = require('query-string');

function* availableStatesWorker(action) {
  try {
    const config = {
      method: 'get',
      url: `geo/getStatesByCountryCode?${queryString.stringify(action.payload, { skipNull: true })}`,
    };
    const { data } = yield call(axios, config);
    yield put(availableStatesSuccess(data));
  } catch (error) {
    yield put(availableStatesFailure(error));
  }
}

function* availableStatesWatcher() {
  yield takeEvery(availableStatesRequest.toString(), availableStatesWorker);
}

export default availableStatesWatcher;
